/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WorkManualGradingUnfinishedParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('unfinished')],
]);
export class WorkManualGradingUnfinished extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WorkManualGradingUnfinishedParser.decode(input).map(res => new WorkManualGradingUnfinished(res));
    }
    static unsafeDecode(input) {
        return WorkManualGradingUnfinished.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WorkManualGradingUnfinishedParser.encode(data);
    }
    static schema() {
        return WorkManualGradingUnfinishedParser.schema();
    }
}
